// extracted by mini-css-extract-plugin
export var buttonContainer = "_8p-1";
export var fontSizeSelect = "_8p-3";
export var formatSelect = "_8p-2";
export var formats = "_8p-4";
export var hidden = "_8p-5";
export var icon = "_8p-6";
export var select = "_8p-0";